import styled from 'styled-components'

const ReviewsListWrapper = styled.div`
  max-height: 280px;
  overflow: auto;
  padding-right: 4px;
`

export default ReviewsListWrapper
